import { useDispatch, useSelector } from 'react-redux';
import { getFormActions } from '../../../utils/form-helpers';
import formConfig from '../../../payment/payment-form-config';
import styles from './input-amount.module.less';
import { ErrorFieldMessage, InputGroup, Input } from '@sb1/ffe-form-react';
import { clearProjectErrors } from '../../project-actions';
import { OPTIONAL_AMOUNT_TEXT_KEY } from '../../i18n/project-i18n-model';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import SuggestedAmounts from './SuggestedAmounts';

const { setFormField } = getFormActions(formConfig);

const InputAmount = ({
    projectProfile = {},
    onAmountChange,
    trackingCategory = 'support',
    hideDefaultAmounts,
    amounts,
    label = '',
    extraMargin = true,
    showLabel = false,
    extraFieldMessage,
    errors,
}) => {
    const paymentForm = useSelector((state) => state.paymentForm);
    const texts = useI18nTexts([OPTIONAL_AMOUNT_TEXT_KEY]);
    const { amount, errors: paymentErrors } = paymentForm;
    const allErrors = {
        ...errors,
        ...paymentErrors,
    };

    const dispatch = useDispatch();

    const giveAmountChangeHandler = (event, validate) => {
        let amount = event.target.value.replace(/[^0-9.]/g, '').match(/^[0-9]+/);
        if (amount) {
            amount = parseInt(amount, 10);
        }
        if (onAmountChange) {
            onAmountChange(amount);
        }
        dispatch(clearProjectErrors());
        dispatch(setFormField('amount', amount, validate));
    };

    const error = allErrors.global || allErrors.amount || '';
    const inputLabel = label || texts[OPTIONAL_AMOUNT_TEXT_KEY];
    return (
        <div>
            {!projectProfile?.hideDefaultPaymentAmounts && !hideDefaultAmounts && (
                <SuggestedAmounts
                    onAmountChange={onAmountChange}
                    trackingCategory={trackingCategory}
                    amounts={amounts}
                />
            )}

            <div className={styles.inputAmountWrapper}>
                <InputGroup
                    label={label || showLabel ? inputLabel : undefined}
                    labelId={'input-amount-label'}
                    extraMargin={extraMargin}
                    fieldMessage={
                        error ? (
                            <ErrorFieldMessage id="inputAmountFormError" className={styles.formError}>
                                {error}
                            </ErrorFieldMessage>
                        ) : extraFieldMessage ? (
                            extraFieldMessage
                        ) : undefined
                    }
                >
                    <Input
                        className={styles.inputAmount}
                        onChange={giveAmountChangeHandler}
                        onBlur={(e) => giveAmountChangeHandler(e, true)}
                        value={amount || ''}
                        inputMode="number"
                        type="text"
                        pattern="[0-9]*"
                        aria-describedby="inputAmountFormError"
                        aria-labelledby={'input-amount-label'}
                        placeholder={0}
                    />
                </InputGroup>
                <div
                    className={[styles.inputAmountPostfix, showLabel && styles.inputWithLabel].join(' ')}
                    aria-label="kroner"
                >
                    kr
                </div>
            </div>
        </div>
    );
};

export default InputAmount;
